import React from 'react';
import Error from "features/errors/components/Error/Error";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      error: error,
    };
  }

  render() {
    if (this.state.error) {
      return <Error level={ this.props.level }
                    error={ this.state.error }/>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
